import { useSelector } from 'react-redux';
import { isAllFeedBucket } from '../redux/selectors/bucket';
export function useNotificationBiString(notification) {
    const isAllFeed = useSelector(isAllFeedBucket);
    return notificationToBiString(notification, isAllFeed);
}
export function notificationToBiString(notification, isAllFeed) {
    var _notification_originator;
    return JSON.stringify({
        message_id: notification.messageId,
        type: notification.type,
        message_class: notification.messageClass,
        bucket: notification.bucket,
        originator: (_notification_originator = notification.originator) === null || _notification_originator === void 0 ? void 0 : _notification_originator.userId,
        folderId: notification.folderId,
        ts: notification.ts,
        is_all_feed: isAllFeed ? 1 : 0
    });
}

//# sourceMappingURL=notificationToBiString.js.map